import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from "@security/service";
import {DEFAULT_INTERRUPTSOURCES, Idle} from "@ng-idle/core";
import {Router} from "@angular/router";
import {LANG_KEY, SAVED_ROUTE_KEY} from "@shared/model";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'serenity-app';

  constructor(translate: TranslateService, private authService: AuthService, private idle: Idle, private router: Router) {
    translate.setDefaultLang('fr');

    // Get the locale stored in the settings; if not existing it will default to french
    const locale = localStorage.getItem(LANG_KEY);
    if (locale !== null && locale !== undefined) {
      translate.use(locale);
    } else {
      const navLocale = navigator.language.split("-")[0];
      if (navLocale) {
        translate.use(navLocale);
      }
    }

    this.idle.setIdle(600);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onTimeout.subscribe(() => {
      localStorage.setItem(SAVED_ROUTE_KEY, this.router.url.split("?")[0]);
      this.authService.logout();
    });

    this.idle.watch();
  }
}
